import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41843174"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "client-logo-fallback"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SkeletonImage = _resolveComponent("SkeletonImage")!

  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(['client-logo', _ctx.className])
  }, [
    (_ctx.hasLogo)
      ? (_openBlock(), _createBlock(_component_SkeletonImage, {
          key: 0,
          src: _ctx.logoSrc,
          alt: _ctx.logoAlt,
          className: "client-logo-img"
        }, null, 8, ["src", "alt"]))
      : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.logoAlt), 1))
  ], 2))
}